import React from 'react';
import { alertError, alertSuccess } from '../config/toast';
import { getregionReq, rmregionReq, addregionReq, updregionReq, getadminReq } from '../config/httpRoutes';
import { Row, Form, Col, Card, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faPlus, faSpinner, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import Loader from '../components/loader';
import TextInput from '../components/textInput';
import SelectIDInput from '../components/selectIdInput';

class Regions extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			name: '',
			// pincode: '',
			city: '',
			admin: '',
			regions: null,
			admins: null,
			errors: { name: '', /* pincode: '', */ city: '', admins: '' },
			loading: false,
			deleteLoading: false,
			fetchLoading: true,
			form: false,
			id: '',
		};
	}

	componentDidMount() {
		this.getRegions();
		this.getPreReqs();
	}

	getPreReqs = async () => {
		try {
			const admins = (await getadminReq()).data;
			this.setState({
				admins
			});
		} catch(err) {
			alertError("Could not fetch required data");
		}
	}

	getRegions = () => {
		this.setState({fetchLoading: true});
		getregionReq()
		.then( (res) => {
			this.setState({regions: res.data, form: false});
		}).catch( (err) => {
			alertError(err.response?.data?.msg || "Could not fetch regions");
		}).finally( () => {
			this.setState({fetchLoading: false});
		});
	}

	rmRegion = (id, index) => {
		this.setState({deleteLoading: true});
		rmregionReq({id})
		.then( (res) => {
			const { regions } = this.state;
			regions.splice(index, 1);
			this.setState({regions});
		}).catch( (err) => {
			alertError(err.response?.data?.msg || "Could not remove region");
		}).finally( () => {
			this.setState({deleteLoading: false});
		});
	}
	
	handleChange = ({ target: { name, value } }) => {
		if(name === 'pincode') {
			this.setState({[name]: ((parseInt(value) || '').toString()).slice(0, 6) || ''});
		} else {
			this.setState({[name]: value});
		}
	}

	validate = () => {
		const { name, /* pincode, */ city, admin } = this.state;
		let errors = { name: '', /* pincode: '', */ city: '', admin: '' }, isValid = true;

		if(!name) {
			errors.name = "Enter name to continue";
			isValid = false;
		}
		// if(!pincode) {
		// 	errors.pincode = "Enter pincode to continue";
		// 	isValid = false;
		// }
		if(!city) {
			errors.city = "Enter city to continue";
			isValid = false;
		}
		if(!admin) {
			errors.admin = "Select admin to continue";
			isValid = false;
		}

		this.setState({errors});
		return isValid;
	}

	handleSubmit = (e) => {
		e.preventDefault();
		const { id, name, /* pincode, */ city, admin } = this.state;
		if(this.validate()) {
			if(id) {
				this.setState({loading: true});
				updregionReq({id, name, /* pincode, */ city: city.toLowerCase(), admin})
				.then( (res) => {
					this.setState({loading: false});
					alertSuccess("Region updated");
					this.getRegions();
				}).catch( (err) => {
					this.setState({loading: false});
					alertError(err?.response?.data?.msg || err?.response?.data?.message || "Could not complete request");
				});
			} else {
				this.setState({loading: true});
				addregionReq({name, /* pincode, */ city: city.toLowerCase(), admin})
				.then( (res) => {
					this.setState({loading: false});
					alertSuccess("Region added");
					this.getRegions();
				}).catch( (err) => {
					this.setState({loading: false});
					alertError(err?.response?.data?.msg || err?.response?.data?.message || "Could not complete request");
				});
			}
		}
	}

	navigateAdd = () => {
		this.setState({ id: '', name: '', /* pincode: '', */ city: '', admin: '', errors: {name: '', /* pincode: '', */ city: '', admin: ''}, loading: false, form: true });
	}

	navigateEdit = (id, name, /* pincode, */ city, admin) => {
		this.setState({ id, name, /* pincode, */ city, admin, errors: {name: '', /* pincode: '', */ city: '', admin: ''}, loading: false, form: true });
	}

	render() {
		const { id, name, /* pincode, */ city, admin, admins, regions, deleteLoading, errors, loading, fetchLoading, form } = this.state;
		const { handleChange, handleSubmit, navigateAdd, navigateEdit, rmRegion } = this;
		return (
			form ?
				<Row style={{marginLeft: 0, marginRight: 0}}>
					<Col md={{span: 4, offset: 4}} lg={{span: 4, offset: 4}} xs={12}>
						<Card style={{marginTop: '20%'}}>
							<Card.Header>
								<Card.Title style={{textAlign: 'center'}}>{id ? 'Update ' : 'Add '} Region</Card.Title>
							</Card.Header>
							<Card.Body>
								<Form onSubmit={handleSubmit}>
									<Form.Group>
										<TextInput onChange={handleChange} value={name} error={errors.name} name="name" label="Name" />
									</Form.Group>

									{/* <Form.Group>
										<TextInput onChange={handleChange} value={pincode} error={errors.pincode} name="pincode" label="Pin Code" />
									</Form.Group> */}
									<Form.Group>
										<TextInput onChange={handleChange} value={city} error={errors.city} name="city" label="City" />
									</Form.Group>

									<Form.Group>
										<SelectIDInput options={admins} onChange={handleChange} value={admin} error={errors.admin} name="admin" label="Admin" />
									</Form.Group>

									<Button variant="success" type="submit" style={{marginLeft: '30%', width: '40%', marginTop: '25px'}} size="lg" disabled={loading}>
										{loading ?
											<FontAwesomeIcon icon={faSpinner} spin />
										:
											'Save'
										}
									</Button>
								</Form>
							</Card.Body>
						</Card>
					</Col>
				</Row>
			:
				<Row style={{marginLeft: 0, marginRight: 0, paddingLeft: '10%', paddingRight: '10%', paddingTop: '5%'}}>
					<Col md={12} style={{justifyContent: 'flex-end', display: 'flex', marginTop: '10px', marginBottom: '15px'}}>
						<Button variant="success" onClick={navigateAdd} size="md">
							<FontAwesomeIcon icon={faPlus} /> Add Region
						</Button>
					</Col>
					{fetchLoading && <Loader />}
					{Array.isArray(regions) ?
						regions.length > 0 ?
							<div className="table-responsive">
								<table className="table table-hover table-attendance">
									<thead>
										<tr>
											<th>Name</th>
											{/* <th>Pincode</th> */}
											<th>City</th>
											<th>Admin</th>
											<th className="th1">Action</th>
										</tr>
									</thead>
									<tbody>
										{regions.map(({ id, name, /* pincode, */ city, admin }, i) =>
											<tr key={i}>
												<td>{name}</td>
												{/* <td>{pincode}</td> */}
												{/* <td className="text-capitalize">{city}</td> */}
												<td>{city}</td>
												<td>{admin?.name}</td>
												<td className="text-center">
													<div className="course-control-box icons-container d-flex">
														<OverlayTrigger overlay={<Tooltip>Edit</Tooltip>} delay={{ show: 150, hide: 150 }} >
															<FontAwesomeIcon icon={faEdit} className="disabled-icon font-16 cursor-pointer mr-3" onClick={(e) => { navigateEdit(id, name, /* pincode, */ city, admin?.id) }} />
														</OverlayTrigger>
														<OverlayTrigger overlay={<Tooltip>Delete</Tooltip>} delay={{ show: 150, hide: 150 }}>
															<FontAwesomeIcon icon={faTrashAlt} className="disabled-icon font-16 cursor-pointer" onClick={(e) => { rmRegion(id, i) }} />
														</OverlayTrigger>
													</div>
												</td>
											</tr>
										)}
									</tbody>
								</table>
							</div>
						:
							<p style={{position: 'fixed', marginLeft: '34%', marginTop: '20%'}}>No regions found.</p>
					:
						<></>
					}
				</Row>
		);
	}
}

export default Regions;